import { BaseDto } from '../base.dto';
import { UserBriefDto } from '../user-brief.dto';
import { MerchantDto } from '../merchant.dto';
import { EmployeeDto } from '../employee.dto';
import {
  IsBoolean,
  IsInt,
  IsISO8601,
  IsNumber,
  IsOptional,
  IsString,
  Length,
  Matches
} from 'class-validator';
import { Exclude } from 'class-transformer';
import { validationPatterns } from '../../constants';

export class BankingDepositPatchDto extends BaseDto {
  @IsOptional()
  @IsInt()
  merchantId: number;

  @IsOptional()
  @IsInt()
  depositUserId: number;

  @IsOptional()
  @IsInt()
  redeemedByEmployeeId: number;

  @IsOptional()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  collectedDay: string;

  @IsOptional()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  redemptionDate: string;

  @IsOptional()
  @IsISO8601()
  redeemedDate: Date;

  @IsOptional()
  @IsBoolean()
  isRedeemed: boolean;

  @IsOptional()
  @IsBoolean()
  isHeadOffice: boolean;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  amount: number;

  @IsOptional()
  @IsString()
  @Length(0, 100)
  @Matches(validationPatterns.nameValidation)
  customerName: string;

  @IsOptional()
  @IsString()
  @Length(0, 20)
  @Matches(validationPatterns.digits)
  customerPhone: string;

  @IsOptional()
  @IsString()
  @Length(0, 254)
  @Matches(validationPatterns.usernameOrEmail)
  customerEmail: string;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description: string;

  @IsOptional()
  @Exclude()
  depositUser: UserBriefDto;

  @IsOptional()
  @Exclude()
  redeemedByEmployee: EmployeeDto;

  @IsOptional()
  @Exclude()
  depositEmployee: EmployeeDto;

  @IsOptional()
  @Exclude()
  merchant: MerchantDto;

  @IsOptional()
  @IsInt()
  invoiceId: number;

  @IsOptional()
  @IsInt()
  status: number;
}
